




































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import UserEdit from '@/components/administration/Users/UserEdit.vue';
import ScreenEdit from '@/components/administration/screens/ScreenEdit.vue';
import RoleEdit from '@/components/administration/Users/RoleEdit.vue';
import RoleUsers from '@/components/administration/Users/RoleUsers.vue';

import CustomerService from '@/services/CustomerService';
import Customer from '@/models/Customer';

import DataGrid from '@/components/reusable/datagrid/DataGrid.vue';
import IDataGrid from '@/components/reusable/datagrid/IDataGrid';
import DataGridOptions from '@/components/reusable/datagrid/DataGridOptions';
import UserService from '../../../services/UserService';

@Component({
    components: {
        DataGrid,
        UserEdit,
        ScreenEdit,
        RoleEdit,
        RoleUsers
    }
})
export default class Companies extends Vue {
    private Id: number = 0;

    private BcItems: any = [];
    private Model: Customer = new Customer();
    private UserGridOptions: DataGridOptions;
    private ScreenGridOptions: DataGridOptions;
    private RoleGridOptions: DataGridOptions;
    private UserSearchTerms: any;
    private ScreenSearchTerms: any;
    private RoleSearchTerms: any;

    private SelectedUser: number = 0;
    private SelectedScreen: number = 0;
    private SelectedRole: number = 0;

    constructor() {
        super();
        this.UserGridOptions = new DataGridOptions();
        this.ScreenGridOptions = new DataGridOptions();
        this.RoleGridOptions = new DataGridOptions();

        this.BcItems = [
            { text: 'Admin', to: '/admin' },
            { text: 'Companies', to: '/admin/companies' },
            { text: 'Details', to: '' }
        ];
    }

    private created() {
        this.Id = parseInt(this.$route.params['id'], 10);
        this.UserSearchTerms = { Customer: this.Id };

        this.InitUserGrid();
        this.InitScreenGrid();
        this.InitRoleGrid();

        this.LoadCustomer(this.Id);
    }

    private async LoadCustomer(id: number) {
        const customerService = new CustomerService();
        const response = await customerService.LoadCustomer(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async InitUserGrid() {
        this.UserGridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.userGetList;
        this.UserGridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.userDelete;
        this.UserGridOptions.HasDelete = true;
        this.UserGridOptions.ShowHeader = true;
        this.UserSearchTerms = { Customer: this.Id };
        this.UserGridOptions.PageSize = 10;
        this.UserGridOptions.Styles.Header = ['detail-header'];
        this.UserGridOptions.Styles.Cell = ['gridcell'];
        this.UserGridOptions.Columns = [
            { Title: 'Id', FieldName: 'Id', Visible: false },
            { Title: 'First Name', FieldName: 'FirstName', Visible: true },
            { Title: 'LastName', FieldName: 'LastName', Visible: true },
            { Title: 'User Name', FieldName: 'UserName', Visible: true }
        ];
    }

    private InitScreenGrid() {
        this.ScreenGridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.screenGetList;
        this.ScreenGridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.screenDelete;
        this.ScreenGridOptions.HasDelete = true;
        this.ScreenGridOptions.ShowHeader = true;
        this.ScreenGridOptions.RowSelection = true;
        this.ScreenGridOptions.UrlRouting = '/admin/screens/details/';
        this.ScreenSearchTerms = { Customer: this.Id };
        this.ScreenGridOptions.PageSize = 10;
        this.ScreenGridOptions.Styles.Header = ['detail-header'];
        this.ScreenGridOptions.Styles.Cell = ['gridcell'];
        this.ScreenGridOptions.Columns = [
            { Title: 'Id', FieldName: 'Id', Visible: false },
            { Title: 'Screen Name', FieldName: 'Name', Visible: true },
            { Title: 'Active', FieldName: 'Active', Visible: true }
        ];
    }

    private InitRoleGrid() {
        this.RoleGridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.roleGetList;
        this.RoleGridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.roleDelete;
        this.RoleGridOptions.HasDelete = true;
        this.RoleGridOptions.ShowHeader = true;
        this.RoleSearchTerms = { Customer: this.Id };
        this.RoleGridOptions.PageSize = 10;
        this.RoleGridOptions.Styles.Header = ['detail-header'];
        this.RoleGridOptions.Styles.Cell = ['gridcell'];
        this.RoleGridOptions.Columns = [
            { Title: 'Id', FieldName: 'Id', Visible: false },
            { Title: 'Name', FieldName: 'Name', Visible: true }
        ];
    }

    private ShowEditUserForm(id: number) {
        this.SelectedUser = id;
        this.$bvModal.show('modal-useredit');
    }

    private OnScreenDetails(screenId: number) {
        const paramsObj = {
            id: screenId.toString()
        };

        const companyId: string = this.Model.Id.toString();
        this.$router.push({ name: 'admin_screendetails', params: paramsObj });
    }

    private OnScreenEdit(id: number) {
        this.SelectedScreen = id;
        this.$bvModal.show('modal-screenedit');
    }

    private OnRoleEdit(id: number) {
        this.SelectedRole = id;
        this.$bvModal.show('modal-roleedit');
    }

    private OnRoleUsersEdit(id: number) {
        this.SelectedRole = id;
        this.$bvModal.show('modal-roleusers');
    }

    private OnCloseEditForm(opt: number) {
        if (opt === 1) {
            this.$bvModal.hide('modal-useredit');
        } else if (opt === 2) {
            this.$bvModal.hide('modal-screenedit');
        } else if (opt === 3) {
            this.$bvModal.hide('modal-roleedit');
        } else if (opt === 4) {
            this.$bvModal.hide('modal-roleusers');
        }
    }

    private OnChangesSaved(opt: number) {
        this.$bvToast.toast('Changes were saved successfully.',
            {
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000,
                toastClass: 'toast-success'
            });

        if (opt === 1) {
            (this.$refs.usersDataGrid as unknown as IDataGrid).Reload(true);
        } else if (opt === 2) {
            (this.$refs.screensDataGrid as unknown as IDataGrid).Reload(true);
        } else if (opt === 3) {
            (this.$refs.rolesDataGrid as unknown as IDataGrid).Reload(true);
        }
    }
}
